import SearchPagination from './SearchPagination';
import SearchPeerResult from './SearchPeerResult';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const SearchPeerResults = ({ history, limit, page, peers, queryParams, searching, onPageChange, breadCrumbs }) => {
  const changePage = (newPage) => () => {
    if (!searching) {
      onPageChange(newPage);
    }
  };

  const renderSearchResultTitle = (numResults) =>
    `${numResults} ${numResults === 1 ? 'practitioner' : 'practitioners'} match your search criteria`;

  if (!peers) return null;

  const { matches, totalItems } = peers;

  return (
    <section className="PractitionerController">
      <div className="col-lg-12">
        <h2>{renderSearchResultTitle(totalItems)}</h2>
        {matches.map((match) => (
          <SearchPeerResult key={match['Person ID']} history={history} peer={match} queryParams={queryParams} breadCrumbs={breadCrumbs} />
        ))}
        <div className="clearfix" />
        <SearchPagination changePage={changePage} limit={limit} page={page} results={peers} searching={searching} />
      </div>
    </section>
  );
};

SearchPeerResults.propTypes = {
  history: PropTypes.object,
  limit: PropTypes.number,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  peers: PropTypes.object,
  queryParams: PropTypes.object,
  searching: PropTypes.bool,
  breadCrumbs: PropTypes.array,
};

const mapStateToProps = (state) => ({
  peers: state.odooForm.peers,
});

export default connect(mapStateToProps)(SearchPeerResults);
